/**
 * @file CrossSearchDialog.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-09-03
 * @modified 2026-09-03
 */

import React from 'react';
import { createPortal } from 'react-dom';
import { CROSS_SEARCH_TARGETS } from '../utils/crossSearch';
import './CrossSearchDialog.css';

/**
 * "Where do you want to look for this item?" — three destinations, not a
 * confirm.
 *
 * ConfirmDialog would have been the quick answer, but it offers one action and
 * a way out, and this is a choice between three equal options. Forcing it into
 * that shape would have meant either three dialogs or a dropdown inside a
 * confirm, both of which cost more clicks than the thing they are asking about.
 */
function CrossSearchDialog({ isOpen, itemCode, itemName, onChoose, onCancel }) {
  if (!isOpen) return null;

  return createPortal(
    <div className="cross-search-overlay" onClick={onCancel}>
      <div className="cross-search-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="cross-search-head">
          <span className="material-symbols-rounded">search</span>
          <div>
            <h3>Search for this item</h3>
            <p>
              <span className="item-code">{itemCode}</span>
              {itemName ? <span className="cross-search-name">{itemName}</span> : null}
            </p>
          </div>
        </div>

        <div className="cross-search-options">
          {CROSS_SEARCH_TARGETS.map((target) => (
            <button
              key={target.key}
              type="button"
              className="cross-search-option"
              onClick={() => onChoose(target)}
            >
              <span className="material-symbols-rounded">{target.icon}</span>
              <span className="cross-search-option-text">
                <span className="cross-search-option-label">{target.label}</span>
                <span className="cross-search-option-desc">{target.description}</span>
              </span>
              <span className="material-symbols-rounded cross-search-go">chevron_right</span>
            </button>
          ))}
        </div>

        <div className="cross-search-foot">
          <button data-read-safe type="button" className="btn-secondary btn-sm" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default CrossSearchDialog;
